'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _viewports = require('./viewports');

var _viewports2 = _interopRequireDefault(_viewports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewportManager = function (_Component) {
  _inherits(ViewportManager, _Component);

  function ViewportManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewportManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewportManager.__proto__ || Object.getPrototypeOf(ViewportManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = { viewport: null, viewportWidth: null, windowWidth: null }, _this.updateViewport = function () {
      var windowWidth = window.innerWidth,
          currentViewport = _this.state.viewport,
          _this$props = _this.props,
          viewports = _this$props.viewports,
          onViewportChange = _this$props.onViewportChange,
          onWindowWidthChange = _this$props.onWindowWidthChange,
          logInfo = _this$props.logInfo;

      var deviceViewport = Object.entries(viewports).sort(function (a, b) {
        return a[1] < b[1];
      }).find(function (viewport) {
        return windowWidth >= viewport[1];
      });
      var newState = {
        viewport: deviceViewport[0],
        viewportWidth: deviceViewport[1],
        windowWidth: windowWidth
      };
      if (onViewportChange && currentViewport !== newState.viewport) {
        onViewportChange(newState);
      }
      if (onWindowWidthChange) {
        onWindowWidthChange(newState);
      }
      if (logInfo) {
        console.groupCollapsed('viewport info');
        console.log('viewport name: ' + newState.viewport);
        console.log('viewport min width: ' + newState.viewportWidth);
        console.log('window width: ' + newState.windowWidth);
        console.groupEnd();
      }
      _this.setState(newState);
    }, _this.render = function () {
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewportManager, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateViewport();

      window.addEventListener('resize', this.updateViewport, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateViewport);
    }
  }]);

  return ViewportManager;
}(_react.Component);

ViewportManager.propTypes = {
  viewports: _propTypes2.default.object,
  onViewportChange: _propTypes2.default.func,
  onWindowWidthChange: _propTypes2.default.func,
  logInfo: _propTypes2.default.bool
};
ViewportManager.defaultProps = {
  viewports: Object.freeze(_viewports2.default)
};
exports.default = ViewportManager;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/ViewportManager/ViewportManager.js